/* eslint-disable prefer-const, consistent-return */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import {
  ApplePayActions,
  PaymentRequestActions,
  PoyntPaymentRequestActions,
  DigitalWalletStore,
  ProductOptions
} from '../../utils/ols-core/';
import {
  ProductDetailStore,
  ProductActions
} from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import {
  OlsConfigStore,
  CartActions,
  CartStore,
  RouteHandler,
  ScrollWidgetActions,
  ShopViewConstants
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { uniqBy, values, includes, cloneDeep } from 'lodash';
import { initWidgets } from '../../utils/YotpoUtils';
import PixelTracker from '../../utils/PixelTracker';
import GoogleAnalytics from '../../utils/GoogleAnalytics';
import { hasSalePrice } from '../utils/ProductUtils';
import { ErrorMessage, Fetching, ProductList1, ProductList2 } from '../lazy';
import ComingSoonModal from '../ComingSoonModal';
import ProductDetail1 from './Layout1';
import getStyles from './getStyles';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';
import { mapContextToProps } from '../OlsShopContext';
import QuickViewLayout from '../products/QuickView/layout';
import GalleryDetail from '../../../layouts/shop2/GalleryDetail';

const ProductListMapping = { ProductList1, ProductList2 };

function hideEmptyStars() {
  const selector = '.ratings-review-wrapper .write-review-btn-hidden';
  const noReviewElements = document.querySelectorAll(selector);
  for (const reviewElement of noReviewElements) {
    // NEMO-8726: hide empty stars on PDP page
    reviewElement.previousSibling.previousSibling.style.display = 'none';
  }
}

export class ProductDetailBase extends Component {
  static propTypes = {
    actionLinkText: PropTypes.string,
    product: PropTypes.object,
    staticContent: PropTypes.object,
    renderMode: PropTypes.string,
    category: PropTypes.string,
    render: PropTypes.func,
    useStaticData: PropTypes.bool,
    pdpImageShape: PropTypes.string,
    pdpImageCropMethod: PropTypes.string,
    showSimilarProducts: PropTypes.bool,
    showFacebook: PropTypes.bool,
    showTwitter: PropTypes.bool,
    domainName: PropTypes.string,
    galleryShowBorder: PropTypes.bool,
    imageCropMethod: PropTypes.string,
    galleryImageShape: PropTypes.string,
    translate: PropTypes.func,
    smartRibbonsBestseller: PropTypes.bool,
    smartRibbonsBestsellerOption: PropTypes.string,
    smartRibbonsNewProduct: PropTypes.bool,
    smartRibbonsNewProductOption: PropTypes.string,
    closeQuickView: PropTypes.func,
    isQuickView: PropTypes.bool,
    isGalleryDetail: PropTypes.bool,
    quickViewWidth: PropTypes.number,
    useBruce: PropTypes.bool,
    olsProxyBaseUrl: PropTypes.string,
    isReverse: PropTypes.bool,
    productListComponent: PropTypes.string,
    ribbonText: PropTypes.string,
    ribbonStyle: PropTypes.object,
    productDetailClick: PropTypes.func,
    isShop2: PropTypes.string
  };

  static defaultProps = {
    render: props => <ProductDetail1 { ...props } />,
    translate: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.getStoreState(),
      hasAddedToCartLabel: false,
      lowInventoryExperiment: {
        bucket: null,
        data: null,
        loading: true,
        error: null
      }
    };
    this.state.similarProductsFinishedLoading = false;
  }

  UNSAFE_componentWillMount() {
    // Set required personalizations
    ProductDetailStore.addListener('change', this.onStoreChange);
    CartStore.addListener('change', this.onStoreChange);
    OlsConfigStore.addListener('change', this.onOlsConfigChange);
    OlsConfigStore.addListener('change', this.onStoreChange);
    DigitalWalletStore.addListener('change', this.onDigitalWalletChange);
    this.initPaymentRequest();
  }

  componentWillUnmount() {
    ProductDetailStore.removeListener('change', this.onStoreChange);
    CartStore.removeListener('change', this.onStoreChange);
    OlsConfigStore.removeListener('change', this.onOlsConfigChange);
    OlsConfigStore.removeListener('change', this.onStoreChange);
    DigitalWalletStore.removeListener('change', this.onDigitalWalletChange);
  }

  clearProduct() {
    this.setState({ product: null });
  }

  componentDidMount() {
    // For zero-state. Don't attempt to fetch any real product data
    if (this.props.useStaticData) return null;

    setTimeout(() => {
      this.clearProduct();
      ProductActions.loadProduct();
      this.setState({ initiatedFetch: true });
    }, 0);

    const fetchExperimentDetails = async () => {
      try {
        this.setState(prevState => ({
          lowInventoryExperiment: {
            ...prevState.lowInventoryExperiment
          }
        }));
      } catch (err) {
        this.setState(prevState => ({
          lowInventoryExperiment: {
            ...prevState.lowInventoryExperiment,
            error: err
          }
        }));
        console.error('Error fetching experiment details:', err);
      } finally {
        this.setState(prevState => ({
          lowInventoryExperiment: {
            ...prevState.lowInventoryExperiment,
            loading: false
          }
        }));
      }
    };

    fetchExperimentDetails();
  }

  componentDidUpdate(prevProps, prevState) {
    initWidgets(hideEmptyStars, 'hideEmptyStarsDetail');
    const product =
      this.props.isShop2 && this.props.product ? this.props.product : this.state.product;
    if (prevState.fetching && !this.state.fetching && product && product.id) {
      try {
        PixelTracker.logViewContent();
        GoogleAnalytics.logViewItem();
      } catch (e) {
        console.error('Error logging view content:', e);
      }
    }

    const hasProductChanged =
      prevState.product && this.state.product && prevState.product.slug !== this.state.product.slug;
    const hasSimilarProductsChanged =
      prevProps.showSimilarProducts !== this.props.showSimilarProducts;

    if (hasProductChanged || hasSimilarProductsChanged) {
      window.setTimeout(() => ProductActions.loadSimilarProducts(), 0);
    }
  }

  getStoreState = () => {
    const { isShop2, product: productFromProps } = this.props;
    const {
      fetching,
      error,
      errorRetryable,
      product: productFromState,
      paymentRequestButtonClicked,
      selectedVariantSku,
      similarProducts
    } = ProductDetailStore.getState();
    const product = isShop2 && productFromProps ? productFromProps : productFromState;

    const { processing } = CartStore.getState();
    const { variantMap, optionValues, priceTable, optionOrder } =
      ProductOptions.getVariantData(product);

    const productOptionOrder = (product && product.product_option_order) || [];
    const { personalizationMap } = ProductOptions.getPersonalizationData(product);
    const selectedVariantOptions = this.determineInitiallySelectedVariantOptions(
      optionValues,
      productOptionOrder,
      selectedVariantSku,
      variantMap
    );
    const { inSession } = DigitalWalletStore.getState();

    const oldId = this.state && this.state.product && this.state.product.id;
    const newId = product && product.id;
    const shouldResetAssetIndex = oldId !== newId;

    const currentVariant = this.determineVariant(
      false,
      product,
      variantMap,
      selectedVariantOptions
    );

    return {
      fetching,
      error,
      errorRetryable,
      product,
      similarProducts,
      productOptionOrder,
      processing,
      variantMap,
      optionValues,
      priceTable,
      optionOrder,
      personalizationMap,
      selectedVariantOptions,
      inSession,
      applePayIsAvailable: this.checkApplePayAvailability(),
      quantity: (this.state && this.state.quantity) || 1,
      selectedVariant: currentVariant.id,
      selectedVariantSku: currentVariant.sku,
      selectedPersonalizations: this.determinePersonalizations(product, personalizationMap),
      hasAttemptedPurchase: paymentRequestButtonClicked,
      currentAssetIndex: shouldResetAssetIndex
        ? 0
        : (this.state && this.state.currentAssetIndex) || 0,
      assetChangedByVariantSelection: false
    };
  };

  onClickThumbnail = (newIndex, assetChangedByVariantSelection = false) => {
    this.setState({
      currentAssetIndex: newIndex,
      assetChangedByVariantSelection: assetChangedByVariantSelection
    });
  };

  checkApplePayAvailability = () => {
    const { stripe_config, poynt_config } = OlsConfigStore.getState();
    const { applePayIsAvailable, googlePayIsAvailable, stripeWasLoaded, poyntWasLoaded } =
      DigitalWalletStore.getState();

    if (poyntWasLoaded) {
      return (applePayIsAvailable || googlePayIsAvailable) && poynt_config.with_apple_pay;
    }

    if (stripeWasLoaded) {
      return applePayIsAvailable && stripe_config?.apple_pay_on_product_detail;
    }

    return false;
  };

  initPaymentRequest = () => {
    const { poyntWasLoaded, stripeWasLoaded } = DigitalWalletStore.getState();
    const { configWasLoaded, stripe_config, poynt_config } = OlsConfigStore.getState();

    if (poyntWasLoaded || stripeWasLoaded || !configWasLoaded) return;

    if (poynt_config?.with_apple_pay) {
      PoyntPaymentRequestActions.init();
    } else if (stripe_config?.with_apple_pay) {
      if (stripe_config.with_payment_request) {
        PaymentRequestActions.init();
      } else {
        const staticContent = this.props.staticContent || {};
        ApplePayActions.init(staticContent.apple_pay);
      }
    }
  };

  onStoreChange = () => {
    this.setState({
      ...this.getStoreState()
    });
    this.getStoreState();

    if (
      !this.state.fetching &&
      this.state.product &&
      this.props.showSimilarProducts &&
      !this.state.similarProductsFinishedLoading
    ) {
      this.setState({
        similarProductsFinishedLoading: true
      });
      window.setTimeout(() => {
        if (this.state.product) {
          ProductActions.loadSimilarProducts(this.state.product.slug);
        }
      }, 0);
    }
  };

  onOlsConfigChange = () => {
    this.initPaymentRequest();
  };

  onDigitalWalletChange = () => {
    const { poyntWasLoaded, stripeWasLoaded, availabilityWasChecked, inSession } =
      DigitalWalletStore.getState();
    const { stripe_config, poynt_config } = OlsConfigStore.getState();

    if (poyntWasLoaded && poynt_config.with_apple_pay) {
      if (availabilityWasChecked) {
        this.setState({
          inSession,
          applePayIsAvailable: this.checkApplePayAvailability()
        });
      } else {
        setTimeout(() => PoyntPaymentRequestActions.checkAvailability(), 0);
      }
    } else if (stripeWasLoaded) {
      if (availabilityWasChecked) {
        this.setState({
          inSession,
          applePayIsAvailable: this.checkApplePayAvailability()
        });
      } else {
        setTimeout(() => {
          if (stripe_config.with_payment_request) {
            PaymentRequestActions.checkAvailability();
          } else {
            ApplePayActions.checkAvailability();
          }
        }, 0);
      }
    }
  };

  get isEditMode() {
    const { renderMode } = this.props;
    return renderMode === 'EDIT';
  }

  handleProductQuantityChange = e => {
    let quantity = e.target.value;

    if (quantity > 999) {
      quantity = 999;
    } else if (quantity !== '' && quantity < 1) {
      quantity = 1;
    }

    this.setState({
      quantity: quantity
    });
    this.clearProductQuantityErrorMessages();
  };

  buildProductPersonalizationOptions = () => {
    let options = {};
    let personalizations_attributes = [];
    const { personalizationMap, selectedPersonalizations } = this.state;

    const personalizationOrder = this.getPersonalizationOrder().filter(position =>
      selectedPersonalizations.hasOwnProperty(position.reference_id)
    );

    personalizations_attributes = personalizationOrder.map(position => {
      const personalization = personalizationMap[position.reference_id];

      if (personalization.kind === 'list') {
        return {
          name: personalization.name,
          option_value_id: personalization.option_values.find(
            optionValue =>
              optionValue.id === parseInt(selectedPersonalizations[position.reference_id], 10)
          ).ov_id,
          value: ''
        };
      }

      return {
        name: personalization.name,
        value: selectedPersonalizations[position.reference_id] || ''
      };
    });

    if (personalizations_attributes.length) {
      options.personalizations_attributes = personalizations_attributes;
    }

    return options;
  };

  handleAddToCart = () => {
    const { priceTable, selectedVariant, product } = this.state;
    const lowInventoryThreshold = product.low_inventory_threshold || 3;
    const variantData = priceTable[selectedVariant] || {};

    if (variantData.totalOnHand <= lowInventoryThreshold && variantData.totalOnHand > 0) {
      Metrics.track(MetricEvents.PRODUCT_DETAIL_PAGE_ADD_TO_CART_WITH_LOW_INVENTORY_CLICK);
    } else {
      Metrics.track(MetricEvents.PRODUCT_DETAIL_PAGE_ADD_TO_CART_CTA_CLICK);
    }

    if (this.isEditMode) return;
    this.canCheckout() && this.addToCart();
  };

  addToCart() {
    if (!this.state.hasAttemptedPurchase && !this.areChoicesValid()) {
      this.setState({ hasAttemptedPurchase: true });
    } else {
      const variantId = this.state.selectedVariant;
      const quantity = this.state.quantity;
      const { isQuickView, closeQuickView, isGalleryDetail } = this.props;

      CartActions.addToCart(variantId, quantity, this.buildProductPersonalizationOptions(), () => {
        PixelTracker.logAddToCart(variantId);

        if (isQuickView) {
          Metrics.track(MetricEvents.QUICK_VIEW_MODAL_ADD_TO_CART_CLICK);

          this.setState({ hasAddedToCartLabel: true });

          setTimeout(() => {
            closeQuickView();
            window.dispatchEvent(new Event('forceOlsCartIconReload'));
          }, 1500);

          return;
        }

        if (isGalleryDetail) {
          Metrics.track(MetricEvents.GALLERY_DETAIL_ADD_TO_CART_CLICK);

          this.setState({ hasAddedToCartLabel: true });

          window.dispatchEvent(new Event('forceOlsCartIconReload'));

          return;
        }

        RouteHandler.navigate(ShopViewConstants.CART);
        ScrollWidgetActions.scrollShopWidget();
        PixelTracker.logAddToCart(variantId);
        GoogleAnalytics.logAddToCart(variantId, +quantity);
      });
    }
  }

  handleApplePayClick = event => {
    event.preventDefault();
    this.canCheckout() && this.applePayProcess();
  };

  applePayProcess() {
    if (!this.state.hasAttemptedPurchase && !this.areChoicesValid()) {
      this.setState({ hasAttemptedPurchase: true });
    } else {
      const prices = this.determinePrice();
      const price = prices.onSale ? prices.salePrice : prices.price;
      ApplePayActions.startSession({
        init_page: 'product_detail',
        variant: {
          id: this.state.selectedVariant,
          price: price,
          quantity: this.state.quantity,
          options: this.buildProductPersonalizationOptions()
        }
      });
      Metrics.track(MetricEvents.PDP_APPLE_PAY_BUTTON_CLICK);
    }
  }

  getVariantData = () => {
    const prices = this.determinePrice();
    const price = prices.onSale ? prices.salePrice : prices.price;

    var variant = {
      canCheckout: false,
      triedCheckout: this.state.hasAttemptedPurchase
    };
    if (!this.state.hasAttemptedPurchase && !this.areChoicesValid()) {
      this.setState({ hasAttemptedPurchase: true });
    }

    if (this.canCheckout() && this.areChoicesValid()) {
      variant.canCheckout = true;
      variant.values = {
        id: this.state.selectedVariant,
        price: price,
        quantity: this.state.quantity,
        options: this.buildProductPersonalizationOptions()
      };
    }

    return { variant: variant };
  };

  canCheckout = () => {
    const { checkout_allowed } = OlsConfigStore.getState();

    if (!checkout_allowed) {
      this.setState({ show_modal: true });
    }

    return checkout_allowed;
  };

  handleSelectOption = (index, e) => {
    const { selectedVariantOptions } = this.state;

    let newSelectedVariantOptions = selectedVariantOptions;
    let newValue = e.target.value === 'select' ? null : e.target.value;
    newSelectedVariantOptions[index].optionValue = newValue;
    this.setState(
      {
        selectedVariantOptions: newSelectedVariantOptions
      },
      this.determineVariant
    );
    this.clearProductQuantityErrorMessages();
  };

  handleVariantSelectOption = (index, value) => {
    const { selectedVariantOptions } = this.state;

    let newSelectedVariantOptions = selectedVariantOptions;
    let newValue = value;

    newSelectedVariantOptions[index].optionValue = newValue;
    this.setState(
      {
        selectedVariantOptions: newSelectedVariantOptions
      },
      this.determineVariant
    );
    this.clearProductQuantityErrorMessages();
  };

  currentVariant = (product, variantMap, selectedVariantOptions) => {
    product = product || (this.state && this.state.product) || {};
    selectedVariantOptions =
      selectedVariantOptions || (this.state && this.state.selectedVariantOptions) || [];

    let index = 0;
    let currentMap = variantMap || (this.state && this.state.variantMap) || {};
    while (index < selectedVariantOptions.length) {
      if (selectedVariantOptions[index].optionValue === null) {
        // this means that the dropdown has "-- select --" selected. We
        // want to break since we will not be able to find a valid variant
        currentMap = undefined; // eslint-disable-line no-undefined
        break;
      }
      currentMap = currentMap[selectedVariantOptions[index].optionValue];
      if (!currentMap) break;
      index++;
    }

    return currentMap;
  };

  determineVariant = (returnValue, product, variantMap, selectedVariantOptions) => {
    // eslint-disable-line consistent-return
    product = product || (this.state && this.state.product) || {};
    let currentMap = this.currentVariant(product, variantMap, selectedVariantOptions);

    let variantId = null;
    let variantSku = null;
    // eslint-disable-next-line no-undefined
    if (currentMap && currentMap.id !== undefined) {
      variantId = currentMap.id;
      variantSku = currentMap.sku || null;
    } else if (currentMap && product.master) {
      variantId = product.master.id;
      // avoid setting sku here so that products with only no variants (only master) do not contain sku in url
    }

    if (returnValue) return { id: variantId, sku: variantSku };

    this.setState(
      {
        selectedVariant: variantId,
        selectedVariantSku: variantSku
      },
      this.afterVariantSelection
    );

    return { id: variantId, sku: variantSku };
  };

  afterVariantSelection = () => {
    const { selectedVariantSku, product } = this.state;
    const { isQuickView, isGalleryDetail } = this.props;

    if (!product) return;
    this.setThumbnailAfterVariantSelection();

    if (isQuickView || isGalleryDetail) return;

    RouteHandler.rewriteURL({
      replaceState: true,
      view: ShopViewConstants.PRODUCT_DETAIL,
      params: {
        slug: product.slug,
        selectedVariantSku,
        taxonSource: window?.history?.state?.params?.taxonSource
      }
    });
  };

  setThumbnailAfterVariantSelection = () => {
    const { product, selectedVariant } = this.state;

    const assets = product.assets || product.images;

    let selectedVariantAssetIndex = this.grabSelectedVariantAssetIndex(
      product,
      selectedVariant,
      assets
    );
    if (selectedVariantAssetIndex !== -1) {
      this.onClickThumbnail(selectedVariantAssetIndex, true);
    } else if (assets && assets.length && selectedVariant) {
      this.onClickThumbnail(0, true);
    }
  };

  grabSelectedVariantAssetIndex = (product, selectedVariantId, assets) => {
    let index = -1;
    if (!product || !product.variants) return index;

    if (assets && assets.length && selectedVariantId !== null) {
      const selectedVariantObj =
        product.variants.find(variant => variant.id === selectedVariantId) || {};
      const assetIds = selectedVariantObj.asset_ids;
      if (assetIds && assetIds.length) {
        // right now variants can only have 1 asset associated with them. We grab the first one
        index = assets.findIndex(asset => asset.id === assetIds[0]);
      }
    }

    return index;
  };

  determinePersonalizations = product => {
    let selectedPersonalizations = (this.state && this.state.selectedPersonalizations) || {};
    const personalizations = (product && product.personalizations) || [];

    // Clean out personalizations that are left-overs from an old product
    const personalizationIds = personalizations.map(function (p) {
      return p.id;
    });
    for (let key in selectedPersonalizations) {
      if (personalizationIds.indexOf(parseInt(key, 10)) === -1) {
        delete selectedPersonalizations[key];
      }
    }

    // Set required personalizations
    if (!Object.keys(selectedPersonalizations).length) {
      personalizations.forEach(function (p) {
        if (p.required) {
          if (p.kind === 'text') {
            selectedPersonalizations[p.id] = '';
          } else if (p.kind === 'list') {
            // all personalization dropdowns will default
            // to "-- Select --" which we represent as null
            selectedPersonalizations[p.id] = null;
          }
        }
      });
    }

    return selectedPersonalizations;
  };

  findVariantBySku = (mapToCheck, skuToFind) => {
    if (!mapToCheck || !skuToFind) return null;

    if (mapToCheck.hasOwnProperty('sku')) {
      if (mapToCheck.sku === skuToFind) {
        return mapToCheck;
      }

      return null;
    }

    const variantValues = Object.values(mapToCheck);
    for (const value of variantValues) {
      const potentialMatch = this.findVariantBySku(value, skuToFind);
      if (potentialMatch) return potentialMatch;
    }

    return null;
  };

  determineInitiallySelectedVariantOptions = (
    optionValues,
    optionOrder = [],
    sku = null,
    variantMap = {}
  ) => {
    if (!optionValues) return null;

    const order = optionOrder
      .filter(option => option.reference_type === 'Spree::OptionType')
      .map(option => option.reference_id);

    const uniqueOptions = uniqBy(values(optionValues), 'option_type_name').sort((a, b) => {
      return order.indexOf(a.option_type_id) - order.indexOf(b.option_type_id);
    });

    const requiredOptionTypeNames = uniqueOptions.map(function (obj) {
      return obj.option_type_name;
    });
    const defaultArray = requiredOptionTypeNames.map(function (typeName) {
      return { optionValue: null, optionName: typeName };
    });

    if (!defaultArray.length) return [];

    const existingSelection = this.state && this.state.selectedVariantOptions;
    if (existingSelection && existingSelection.length) {
      const optionIds = Object.keys(optionValues);
      let validSelection = true;
      for (let option of existingSelection) {
        if (optionIds.indexOf(option.optionValue) === -1) {
          // case: an existingSelection optionValue no longer exists
          validSelection = false;
          break;
        }
      }

      if (validSelection) return existingSelection;
    }

    if (sku) {
      const initialVariant = this.findVariantBySku(variantMap, sku);
      if (initialVariant && initialVariant.option_values) {
        return initialVariant.option_values.map(o => ({
          optionValue: o.id,
          optionName: o.option_type_name
        }));
      }
    }

    return defaultArray;
  };

  determineAddOnCharges = () => {
    const { selectedPersonalizations, personalizationMap } = this.state;
    let addOnCharges = 0;

    for (const id in selectedPersonalizations) {
      if (selectedPersonalizations.hasOwnProperty(id)) {
        const personalization = personalizationMap[id];

        if (personalization.kind === 'text') {
          addOnCharges += +personalization.increase_by;
        } else if (personalization.kind === 'list') {
          const optionId = selectedPersonalizations[id];
          if (optionId) {
            addOnCharges += +personalization.priceTable[optionId];
          }
        }
      }
    }

    return addOnCharges;
  };

  determinePrice = (includeOptions = true) => {
    let { selectedVariant } = this.state;
    let { isShop2 } = this.props;
    const product = isShop2 && this.props.product ? this.props.product : this.state.product;
    let prices = {};
    const mainProductPrice = {
      price: +product.price,
      salePrice: +product.sale_price,
      onSale: hasSalePrice(product)
    };
    if (!this.isSelectedVariantValid()) {
      // If the selectedVariant is not valid, one of the required option dropdowns has
      // "-- Select --" selected. We still want to show a price to the user immediately,
      // so we grab the price information from the product
      return mainProductPrice;
    }
    if (isShop2) {
      const matchingVariant = product.variants.find(variant => variant.id === selectedVariant);
      if (matchingVariant) {
        prices = {
          price: +matchingVariant.price,
          salePrice: +matchingVariant.sale_price,
          onSale: matchingVariant['on_sale?']
        };
      } else {
        return mainProductPrice;
      }
    } else {
      prices = JSON.parse(JSON.stringify(this.state.priceTable[selectedVariant]));
    }

    if (!includeOptions) {
      return prices;
    }

    const addOnCharges = this.determineAddOnCharges();
    prices.price = +prices.price + addOnCharges;
    if (prices.onSale) {
      prices.salePrice = +prices.salePrice + addOnCharges;
    }
    return prices;
  };

  areChoicesValid = () => {
    return this.isSelectedVariantValid() && this.areSelectedPersonalizationsValid();
  };

  handlePersonalizationChange = (id, enabled, val) => {
    const { selectedPersonalizations } = this.state;
    let newValue = val === 'select' ? null : val;
    if (enabled) {
      selectedPersonalizations[id] = newValue;
    } else {
      delete selectedPersonalizations[id];
    }

    this.setState({
      selectedPersonalizations: selectedPersonalizations
    });
  };

  getInvalidPersonalizationIds = personalizations => {
    const selectedPersonalizations =
      personalizations || (this.state && this.state.selectedPersonalizations) || {};
    const { personalizationMap } = this.state;
    const allPersonalizationIds = Object.keys(personalizationMap);
    const invalidIds = allPersonalizationIds.filter(id => {
      const invalidValues = [undefined, null, '']; // eslint-disable-line no-undefined
      let selectedValue = selectedPersonalizations[id];
      if (typeof selectedValue === 'string') selectedValue = selectedValue.trim();
      // Invalid: personalization is required and user did not pick it
      if (
        selectedPersonalizations.hasOwnProperty(id) &&
        invalidValues.indexOf(selectedValue) !== -1
      ) {
        return true;
      }
      // Personalization pick is valid or not applicable
      return false;
    });
    return invalidIds;
  };

  areSelectedPersonalizationsValid = personalizations => {
    return this.getInvalidPersonalizationIds(personalizations).length === 0;
  };

  isSelectedVariantInStock = () => {
    const { product } = this.state;

    if (
      !product ||
      !product.track_inventory ||
      product.backorderable ||
      !this.isSelectedVariantValid()
    )
      return true;

    const { priceTable, selectedVariant } = this.state;
    const variantData = priceTable[selectedVariant] || {};

    return variantData.inStock === true;
  };

  isSelectedVariantValid = () => {
    const { selectedVariant, priceTable } = this.state;
    return selectedVariant !== null && priceTable[selectedVariant];
  };

  containsNullValues = variantValues => {
    return includes(
      variantValues.map(function (obj) {
        return obj.optionValue;
      }),
      null
    );
  };

  productErrorMessages = type => {
    const { error } = this.state;
    let result = [];

    if (error && error.messages && error.messages[type]) {
      result = error.messages[type];
    }

    return result;
  };

  clearProductQuantityErrorMessages = () => {
    const { error } = this.state;

    if (error && error.messages && error.messages.quantity) {
      error.messages.quantity = null;
      this.setState({ error: error });
    }
  };

  isVariantInStock = (index, optionId) => {
    const variant = this.getCurrentVariant(index, optionId, true);
    const { priceTable } = this.state;
    if (variant === '') {
      // case: invalid variant. For example: ["1", null, "5"]
      return true;
    } else if (!variant) {
      // case: the variant does not exist because the merchant has deleted it
      return false;
    }

    const variantData = priceTable[variant] || {};
    return variantData.inStock === true;
  };

  isVariantAvailable = (index, optionId) => {
    return this.getCurrentVariant(index, optionId, false) !== null;
  };

  getCurrentVariant = (index, optionId, checkInventory) => {
    const { product, selectedVariantOptions, variantMap } = this.state;

    if (!product || !selectedVariantOptions) return '';
    if (checkInventory && !product.track_inventory) return '';

    let changedSelectedVariantOptions = cloneDeep(selectedVariantOptions);
    changedSelectedVariantOptions[index].optionValue = optionId;
    if (this.containsNullValues(changedSelectedVariantOptions)) {
      // We don't want to look at variant combo with null values like: ["1", "5", null]
      return '';
    }
    return this.determineVariant(true, product, variantMap, changedSelectedVariantOptions).id;
  };

  requiredFieldsBlank = () => {
    return !this.areChoicesValid();
  };

  getBlankRequiredFieldsMap = () => {
    const blankRequiredSelectFieldNames = [];
    const blankRequiredTextFieldNames = [];
    const { selectedVariantOptions, personalizationMap } = this.state;

    for (let option of selectedVariantOptions) {
      if (option.optionValue === null) {
        blankRequiredSelectFieldNames.push(option.optionName);
      }
    }
    const invalidPersonalizations = this.getInvalidPersonalizationIds();
    invalidPersonalizations.forEach(invalidId => {
      const personalization = personalizationMap[invalidId];
      if (personalization.kind === 'text') {
        blankRequiredTextFieldNames.push(personalization.name);
      } else {
        blankRequiredSelectFieldNames.push(personalization.name);
      }
    });

    return {
      selectFieldNames: blankRequiredSelectFieldNames,
      textFieldNames: blankRequiredTextFieldNames
    };
  };

  getBlankRequiredFieldsTranslation = (blankRequiredNames, type) => {
    if (!blankRequiredNames || !blankRequiredNames.length) return '';

    const translate = this.props.translate;
    let translation = '';
    let translationKeyBase = 'products.missing_required.' + type;

    if (blankRequiredNames.length === 1) {
      translation = translate(translationKeyBase + '.one', {
        option: blankRequiredNames[0]
      });
    } else if (blankRequiredNames.length === 2) {
      translation = translate(translationKeyBase + '.two', {
        option1: blankRequiredNames[0],
        option2: blankRequiredNames[1]
      });
    } else {
      let translationKeyEnd = blankRequiredNames.length === 3 ? '.three' : '.more';

      translation = translate(translationKeyBase + translationKeyEnd, {
        option1: blankRequiredNames[0],
        option2: blankRequiredNames[1],
        option3: blankRequiredNames[2]
      });
    }

    return translation;
  };

  getPersonalizationOrder = () => {
    const { productOptionOrder } = this.state;

    return productOptionOrder.filter(ot => ot.reference_type !== 'Spree::OptionType');
  };

  get renderProps() {
    const {
      renderMode,
      showSimilarProducts,
      pdpImageShape,
      pdpImageCropMethod,
      translate,
      isQuickView,
      quickViewWidth,
      showFacebook,
      showTwitter,
      domainName,
      isReverse,
      olsProxyBaseUrl,
      isShop2
    } = this.props;
    const { fetching, processing, inSession, quantity, similarProducts, lowInventoryExperiment } =
      this.state;
    const product = isShop2 && this.props.product ? this.props.product : this.state.product;
    const description = product.description_raw || product.description;
    const {
      product_type: productType,
      digital_goods_files: files,
      product_option_order: productOptionOrder
    } = product;

    const personalizationOrder = this.getPersonalizationOrder();
    const variantCount =
      productOptionOrder &&
      productOptionOrder.filter(ot => ot.reference_type === 'Spree::OptionType').length;
    const requiredFieldsBlank = this.state.hasAttemptedPurchase && this.requiredFieldsBlank();
    const isSelectedVariantInStock = this.isSelectedVariantInStock();

    const { stripe_config, poynt_config } = OlsConfigStore.getState();

    return {
      assetChangedByVariantSelection: this.state.assetChangedByVariantSelection,
      baseState: this.state,
      category: this.props.category,
      closeModal: () => this.setState({ show_modal: false }),
      currentAssetIndex: this.state.currentAssetIndex,
      description,
      determineAddOnCharges: this.determineAddOnCharges,
      determinePrice: this.determinePrice,
      fetching,
      files,
      getBlankRequiredFieldsMap: this.getBlankRequiredFieldsMap,
      getBlankRequiredFieldsTranslation: this.getBlankRequiredFieldsTranslation,
      getInvalidPersonalizationIds: this.getInvalidPersonalizationIds,
      handleAddToCart: this.handleAddToCart,
      handleApplePayClick: this.handleApplePayClick,
      getVariantData: this.getVariantData,
      handlePersonalizationChange: this.handlePersonalizationChange,
      handleProductQuantityChange: this.handleProductQuantityChange,
      handleSelectOption: this.handleSelectOption,
      inSession,
      isSelectedVariantInStock,
      isSelectedVariantValid: this.isSelectedVariantValid,
      isVariantAvailable: this.isVariantAvailable,
      isVariantInStock: this.isVariantInStock,
      onClickThumbnail: this.onClickThumbnail,
      personalizationOrder,
      processing,
      product,
      similarProducts,
      showSimilarProducts,
      showFacebook,
      showTwitter,
      domainName,
      galleryShowBorder: this.props.galleryShowBorder,
      imageCropMethod: this.props.imageCropMethod,
      galleryImageShape: this.props.galleryImageShape,
      productErrorMessages: this.productErrorMessages,
      productType,
      quantity,
      stripeConfig: stripe_config,
      poyntConfig: poynt_config,
      renderGeneralWarning: this.renderGeneralWarning,
      renderMode,
      requiredFieldsBlank,
      show_modal: this.state.show_modal,
      translate,
      variantCount,
      pdpImageShape,
      pdpImageCropMethod,
      handleVariantSelectOption: this.handleVariantSelectOption,
      smartRibbonsBestseller: this.props.smartRibbonsBestseller,
      smartRibbonsBestsellerOption: this.props.smartRibbonsBestsellerOption,
      smartRibbonsNewProduct: this.props.smartRibbonsNewProduct,
      smartRibbonsNewProductOption: this.props.smartRibbonsNewProductOption,
      isQuickView,
      quickViewWidth,
      isReverse,
      hasAddedToCartLabel: this.state.hasAddedToCartLabel,
      setHasAttemptedPurchase: () => this.setState({ hasAttemptedPurchase: true }),
      olsProxyBaseUrl,
      lowInventoryExperiment
    };
  }

  renderGeneralWarning = () => {
    const generalErrors = this.productErrorMessages('general_error');
    const { Block } = UX2.Element;
    const styles = {
      textAlign: 'center',
      marginTop: 'large',
      fontColor: 'error'
    };
    return generalErrors.length > 0 ? (
      <Block style={ styles } data-aid={ dataAids.PRODUCT_GENERAL_ERROR }>
        { generalErrors }
      </Block>
    ) : null;
  };

  render() {
    const {
      renderMode,
      render,
      translate,
      isQuickView,
      isGalleryDetail,
      ribbonText,
      ribbonStyle,
      actionLinkText,
      productListComponent,
      isShop2
    } = this.props;
    const { fetching, processing, inSession, error, initiatedFetch } = this.state;

    const product = isShop2 && this.props.product ? this.props.product : this.state.product;
    const ProductListComponent = ProductListMapping[productListComponent];

    if (error && error.status_code === 0) {
      return <ErrorMessage message={ translate('products.error_fetching_product_data') } />;
    }

    if ((!initiatedFetch || fetching) && !product) {
      return <Fetching fetching={ fetching } pageTransition={ true } />;
    }

    if (!product && initiatedFetch) {
      return <ProductListComponent { ...this.props } />;
    }

    const { Block } = UX2.Element;
    const styles = getStyles(this.props);
    const layoutProps = this.renderProps;

    if (isQuickView) {
      return <QuickViewLayout { ...layoutProps } />;
    }

    if (isGalleryDetail) {
      return (
        <GalleryDetail
          actionLinkText={ actionLinkText }
          { ...layoutProps }
          ribbonText={ ribbonText }
          ribbonStyle={ ribbonStyle }
          productDetailClick={ this.props.productDetailClick }
        />
      );
    }

    return (
      <Block style={ styles.wrapper }>
        { this.state.show_modal && (
          <ComingSoonModal
            renderMode={ renderMode }
            closeModal={ () => this.setState({ show_modal: false }) }
          />
        ) }
        { render(layoutProps) }
        <Fetching
          fetching={ fetching || processing || inSession }
          pageTransition={ true }
          transparentBackground={ inSession }
        />
      </Block>
    );
  }
}

export default mapContextToProps(ProductDetailBase, context => ({
  translate: context.translate
}));
